import React from 'react';

interface CharacterPortraitProps {
  name: string;
  label?: string;
  image?: string;
  isWalking?: boolean;
  mirrored?: boolean;
}

const CharacterPortrait: React.FC<CharacterPortraitProps> = ({
  name,
  label,
  image,
  isWalking = false,
  mirrored = false,
}) => {
  const initials = name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const animation = isWalking ? 'guardian-walk 0.8s ease-in-out infinite' : 'guardian-idle 2.5s ease-in-out infinite';
  const displayLabel = label ?? name;

  return (
    <div className="flex flex-col items-center gap-1.5">
      {image ? (
        <img
          src={image}
          alt={name}
          className="w-auto object-contain drop-shadow-lg select-none"
          style={{
            height: 'clamp(180px, 46vh, 480px)',
            animation,
            transform: mirrored ? 'scaleX(-1)' : 'scaleX(1)',
          }}
        />
      ) : (
        <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-indigo-400 flex items-center justify-center shadow-lg border-2 sm:border-[3px] border-indigo-300">
          <span className="text-2xl sm:text-3xl font-bold text-white select-none">{initials}</span>
        </div>
      )}

      <span
        className="px-3 py-1 rounded-full text-xs sm:text-sm font-caudex text-white whitespace-nowrap"
        style={{
          background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(4px)',
          border: '1px solid rgba(255,255,255,0.25)',
        }}
      >
        {displayLabel}
      </span>

      <style>{`
        @keyframes guardian-walk {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          25% { transform: translateY(-4px) rotate(2deg); }
          75% { transform: translateY(-4px) rotate(-2deg); }
        }
        @keyframes guardian-idle {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
      `}</style>
    </div>
  );
};

export default CharacterPortrait;